import script from './component-lib.esm11.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.currentComponent, _vm._b({
    ref: "root",
    tag: "component",
    staticClass: "v-list-item",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.isDisabled,
      "href": _vm.href,
      "to": _vm.to
    },
    on: {
      "click": _vm.handleClick,
      "keydown": _vm.handleKeydown
    }
  }, 'component', Object.assign({}, _vm.itemAttrs, _vm.$attrs), false), [_vm._t("default", null, {
    "active": _vm.isActive,
    "disabled": _vm.disabled
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-bd2c8fe4_0", {
    source: ".v-list-item{background:0 0;align-items:center;border-radius:0;border:none;color:inherit;display:flex;flex:1 1 100%;font-family:var(--g-font-body-family);letter-spacing:normal;min-height:3rem;outline:0;padding:0 1rem;position:relative;text-align:inherit;text-decoration:none;width:100%}.v-list--dense .v-list-item{min-height:2.5rem}.v-list-item:before{background-color:currentColor;border-radius:inherit;bottom:0;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:var(--g-transition-speed)}.v-list-item--disabled{color:var(--g-color-gray-600);pointer-events:none}.v-list-item--disabled .v-list-item__action,.v-list-item--disabled .v-list-item__avatar,.v-list-item--disabled .v-list-item__icon{opacity:.75}.v-list-item--link{cursor:pointer;user-select:none}.v-list-item--link:hover:before{opacity:.04}.v-list-item--link:focus:before{opacity:.08}.v-list-item--active{color:var(--g-color-primary)}.v-list-item--active:before{opacity:.12}.v-list-item__content{align-items:center;align-self:center;display:flex;flex-wrap:wrap;flex:1 1;overflow:hidden;padding:.75rem 0}.v-list--dense .v-list-item__content{padding:.5rem 0}.v-list-item__content>*{line-height:1.1;flex:1 0 100%}.v-list-item__content>:not(:last-child){margin-bottom:.25rem}.v-list-item__subtitle,.v-list-item__title{align-self:center;line-height:1.3;flex:1 1 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-list-item__subtitle--wrap,.v-list-item__title--wrap{white-space:normal;overflow:unset}.v-list-item__title{font-size:1rem;font-weight:500}.v-list-item__subtitle{font-size:.875rem;opacity:.75}.v-list-item__icon{align-self:flex-start;font-size:1.5rem;margin:1rem 0}.v-list--dense .v-list-item__icon{margin:.5rem 0}.v-list-item__action,.v-list-item__avatar,.v-list-item__icon{display:inline-flex;min-width:1.5rem}.v-list-item__action:last-of-type:not(:only-child),.v-list-item__avatar:last-of-type:not(:only-child),.v-list-item__icon:last-of-type:not(:only-child){margin-left:1rem}.v-list-item__action:first-child,.v-list-item__icon:first-child{margin-right:2rem}.v-list-item__action{align-self:center;margin:.75rem 0}.v-list--dense .v-list-item__action{margin:.5rem 0}.v-list-item__avatar{align-self:center;justify-content:flex-start;margin-bottom:.5rem;margin-top:.5rem}.v-list-item__avatar:first-child{margin-right:1rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ListItem = __vue_component__;
export { ListItem as default };